var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-wrapper" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "worker_data ibox-content",
        staticStyle: { "padding-left": "0" }
      },
      [
        _c("div", { staticClass: "nav_cha" }, [_vm._v("体检信息")]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "formInline",
                staticClass: "demo-form-inline",
                attrs: {
                  inline: true,
                  model: _vm.formInline,
                  rules: _vm.rules,
                  "label-width": "120px",
                  "label-position": "right"
                }
              },
              [
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "体检类型：", prop: "mecType" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: { placeholder: "请选择体检类型" },
                        model: {
                          value: _vm.formInline.mecType,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "mecType", $$v)
                          },
                          expression: "formInline.mecType"
                        }
                      },
                      _vm._l(_vm.selectMedType, function(item) {
                        return _c("el-option", {
                          key: item.typeId,
                          attrs: { label: item.mecType, value: item.typeId }
                        })
                      })
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "体检日期：", prop: "checkDate" }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        "value-format": "yyyy-MM-dd",
                        type: "date",
                        placeholder: "选择体检日期",
                        "picker-options": _vm.pickerOptions
                      },
                      on: {
                        change: function($event) {
                          _vm.examine()
                        }
                      },
                      model: {
                        value: _vm.formInline.checkDate,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "checkDate", $$v)
                        },
                        expression: "formInline.checkDate"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "体检单位：" }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "体检单位", disabled: true },
                      model: {
                        value: _vm.formInline.hospital,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "hospital", $$v)
                        },
                        expression: "formInline.hospital"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "主检医师：" }
                  },
                  [
                    _c("el-input", {
                      ref: "disabled",
                      staticStyle: { width: "200px" },
                      model: {
                        value: _vm.formInline.doctor,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "doctor", $$v)
                        },
                        expression: "formInline.doctor"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "nav_cha" }, [_vm._v("儿童信息")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "儿童来源：", prop: "childFromType" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: {
                          disabled: _vm.diSchildFromType,
                          placeholder: "请选择儿童来源"
                        },
                        model: {
                          value: _vm.formInline.childFromType,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "childFromType", $$v)
                          },
                          expression: "formInline.childFromType"
                        }
                      },
                      _vm._l(_vm.selectChild, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.name, value: item.value }
                        })
                      })
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "幼儿园：", prop: "gardenName" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: {
                          disabled: _vm.diSgardenName,
                          placeholder: "请选择幼儿园"
                        },
                        model: {
                          value: _vm.formInline.gardenName,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "gardenName", $$v)
                          },
                          expression: "formInline.gardenName"
                        }
                      },
                      _vm._l(_vm.selectGarden, function(item) {
                        return _c("el-option", {
                          key: item.orgKindID,
                          attrs: { label: item.fullName, value: item.orgKindID }
                        })
                      })
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "姓名：", prop: "childName" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: {
                          disabled: _vm.diSchildName,
                          placeholder: "请选择儿童"
                        },
                        model: {
                          value: _vm.formInline.childName,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "childName", $$v)
                          },
                          expression: "formInline.childName"
                        }
                      },
                      _vm._l(_vm.selectName, function(item) {
                        return _c("el-option", {
                          key: item.childID,
                          attrs: { label: item.childName, value: item.childID }
                        })
                      })
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "性别：", prop: "sex" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        ref: "sex",
                        staticStyle: { width: "200px" },
                        attrs: { disabled: _vm.disSex },
                        model: {
                          value: _vm.formInline.sex,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "sex", $$v)
                          },
                          expression: "formInline.sex"
                        }
                      },
                      [
                        _c("el-option", {
                          key: "男",
                          attrs: { label: "男", value: "1" }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          key: "女",
                          attrs: { label: "女", value: "2" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "出生日期：", prop: "birthday" }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        "value-format": "yyyy-MM-dd",
                        type: "date",
                        disabled: _vm.disBirth
                      },
                      model: {
                        value: _vm.formInline.birthday,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "birthday", $$v)
                        },
                        expression: "formInline.birthday"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "体检年龄：", prop: "birthday" }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "80px" },
                      attrs: { disabled: _vm.disBirth },
                      model: {
                        value: _vm.ageY,
                        callback: function($$v) {
                          _vm.ageY = $$v
                        },
                        expression: "ageY"
                      }
                    }),
                    _vm._v("岁\n                  "),
                    _c("el-input", {
                      staticStyle: { width: "80px" },
                      attrs: { disabled: _vm.disBirth },
                      model: {
                        value: _vm.ageM,
                        callback: function($$v) {
                          _vm.ageM = $$v
                        },
                        expression: "ageM"
                      }
                    }),
                    _vm._v("月\n                ")
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "身份证号码：", prop: "idCard" }
                  },
                  [
                    _c("el-input", {
                      ref: "idCard",
                      staticStyle: { width: "200px" },
                      attrs: { disabled: _vm.disCard },
                      model: {
                        value: _vm.formInline.idCard,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "idCard", $$v)
                        },
                        expression: "formInline.idCard"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "联系人：", prop: "contactPerson" }
                  },
                  [
                    _c("el-input", {
                      ref: "contactPerson",
                      staticStyle: { width: "200px" },
                      attrs: { disabled: _vm.disRela },
                      model: {
                        value: _vm.formInline.contactPerson,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "contactPerson", $$v)
                        },
                        expression: "formInline.contactPerson"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "手机号码：", prop: "relationPhone" }
                  },
                  [
                    _c("el-input", {
                      ref: "relationPhone",
                      staticStyle: { width: "200px" },
                      attrs: { disabled: _vm.disPhone },
                      model: {
                        value: _vm.formInline.relationPhone,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "relationPhone", $$v)
                        },
                        expression: "formInline.relationPhone"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "nav_cha" }, [_vm._v("一般检查")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "star",
                    staticStyle: { width: "350px" },
                    attrs: { label: "身高：", prop: "height" }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      on: {
                        blur: function($event) {
                          _vm.examine1()
                        }
                      },
                      model: {
                        value: _vm.formInline.height,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "height", _vm._n($$v))
                        },
                        expression: "formInline.height"
                      }
                    }),
                    _c("span", [_vm._v(" cm")])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "评价结果：", prop: "heightComment" }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "评价结果", disabled: true },
                      model: {
                        value: _vm.formInline.heightComment,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "heightComment", $$v)
                        },
                        expression: "formInline.heightComment"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "star",
                    staticStyle: { width: "350px" },
                    attrs: { label: "体重：", prop: "weight" }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      on: {
                        blur: function($event) {
                          _vm.examine2()
                        }
                      },
                      model: {
                        value: _vm.formInline.weight,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "weight", _vm._n($$v))
                        },
                        expression: "formInline.weight"
                      }
                    }),
                    _c("span", [_vm._v(" kg")])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "评价结果：", prop: "weightComment" }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "评价结果", disabled: true },
                      model: {
                        value: _vm.formInline.weightComment,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "weightComment", $$v)
                        },
                        expression: "formInline.weightComment"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "体重指数(%)：", prop: "weightPercent" }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "体重指数", disabled: true },
                      model: {
                        value: _vm.formInline.weightPercent,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "weightPercent", $$v)
                        },
                        expression: "formInline.weightPercent"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "肥胖指数(%)：", prop: "fatPercent" }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "肥胖指数", disabled: true },
                      model: {
                        value: _vm.formInline.fatPercent,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "fatPercent", $$v)
                        },
                        expression: "formInline.fatPercent"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "BMI：", prop: "bmiValue" }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "BMI", disabled: true },
                      model: {
                        value: _vm.formInline.bmiValue,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "bmiValue", $$v)
                        },
                        expression: "formInline.bmiValue"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { label: "综合评价：", prop: "overallComment" }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "综合评价", disabled: true },
                      model: {
                        value: _vm.formInline.overallComment,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "overallComment", $$v)
                        },
                        expression: "formInline.overallComment"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.detailList, function(val, num) {
                  return val.valueType == 3 && val.categoryId == 1
                    ? _c(
                        "el-form-item",
                        {
                          key: num,
                          staticStyle: { width: "541px" },
                          attrs: { label: val.mecItemName + "：" }
                        },
                        [
                          _vm._l(_vm.childMecItemList, function(list, num) {
                            return list.itemId == val.mecItemId
                              ? [
                                  [
                                    list.itemResult.indexOf("_") > 0
                                      ? [
                                          _c(
                                            "el-select",
                                            {
                                              ref: val.mecItemId,
                                              refInFor: true,
                                              staticStyle: { width: "200px" },
                                              on: {
                                                change: function($event) {
                                                  _vm.customizeInput(
                                                    $event,
                                                    list,
                                                    val,
                                                    val.mecItemId
                                                  )
                                                }
                                              },
                                              model: {
                                                value: list.itemResult.split(
                                                  "_"
                                                )[0],
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    list.itemResult.split("_"),
                                                    0,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "list.itemResult.split('_')[0]"
                                              }
                                            },
                                            [
                                              _vm._l(
                                                val.valueOptions.split(","),
                                                function(el) {
                                                  return [
                                                    _c("el-option", {
                                                      key: el,
                                                      attrs: {
                                                        label: el,
                                                        value: el
                                                      }
                                                    })
                                                  ]
                                                }
                                              )
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            staticClass: "el-input__inner",
                                            staticStyle: { width: "200px" },
                                            attrs: { name: "subValue" },
                                            domProps: {
                                              value: list.itemResult.split(
                                                "_"
                                              )[1]
                                            },
                                            on: {
                                              change: function($event) {
                                                _vm.changeInp(
                                                  $event,
                                                  val,
                                                  list,
                                                  num
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      : list.itemResult.indexOf("_") < 0
                                        ? [
                                            _c(
                                              "el-select",
                                              {
                                                ref: val.mecItemId,
                                                refInFor: true,
                                                staticStyle: { width: "200px" },
                                                on: {
                                                  change: function($event) {
                                                    _vm.customizeInput(
                                                      $event,
                                                      list,
                                                      val,
                                                      val.mecItemId
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: list.itemResult,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      list,
                                                      "itemResult",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "list.itemResult"
                                                }
                                              },
                                              [
                                                _vm._l(
                                                  val.valueOptions.split(","),
                                                  function(el) {
                                                    return [
                                                      _c("el-option", {
                                                        key: el,
                                                        attrs: {
                                                          label: el,
                                                          value: el
                                                        }
                                                      })
                                                    ]
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        : _vm._e()
                                  ]
                                ]
                              : _vm._e()
                          })
                        ],
                        2
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm._l(_vm.CategoryList, function(item) {
                  return item.id != 1
                    ? _c(
                        "div",
                        [
                          _c("div", { staticClass: "nav_cha" }, [
                            _vm._v(_vm._s(item.categoryName))
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.detailList, function(val, num) {
                            return val.categoryId == item.id
                              ? _c(
                                  "el-form-item",
                                  {
                                    key: num,
                                    staticStyle: { width: "541px" },
                                    attrs: { label: val.mecItemName + "：" }
                                  },
                                  [
                                    _vm._l(_vm.childMecItemList, function(
                                      list,
                                      num
                                    ) {
                                      return list.itemId == val.mecItemId
                                        ? [
                                            val.unit
                                              ? [
                                                  val.valueType == 2 ||
                                                  val.valueType == 1
                                                    ? _c("el-input", {
                                                        staticStyle: {
                                                          width: "200px"
                                                        },
                                                        model: {
                                                          value:
                                                            list.itemResult,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              list,
                                                              "itemResult",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "list.itemResult"
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(_vm._s(val.unit))
                                                  ])
                                                ]
                                              : [
                                                  val.valueType == 3 ||
                                                  val.valueType == 4
                                                    ? [
                                                        list.itemResult.indexOf(
                                                          "_"
                                                        ) > 0
                                                          ? [
                                                              _c(
                                                                "el-select",
                                                                {
                                                                  ref:
                                                                    val.mecItemId,
                                                                  refInFor: true,
                                                                  staticStyle: {
                                                                    width:
                                                                      "200px"
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.customizeInput(
                                                                        $event,
                                                                        list,
                                                                        val,
                                                                        val.mecItemId
                                                                      )
                                                                    }
                                                                  },
                                                                  model: {
                                                                    value: list.itemResult.split(
                                                                      "_"
                                                                    )[0],
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        list.itemResult.split(
                                                                          "_"
                                                                        ),
                                                                        0,
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "list.itemResult.split('_')[0]"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._l(
                                                                    val.valueOptions.split(
                                                                      ","
                                                                    ),
                                                                    function(
                                                                      el
                                                                    ) {
                                                                      return [
                                                                        _c(
                                                                          "el-option",
                                                                          {
                                                                            key: el,
                                                                            attrs: {
                                                                              label: el,
                                                                              value: el
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              list.itemResult.split(
                                                                "_"
                                                              )[0] != "戴镜矫治"
                                                                ? _c("input", {
                                                                    staticClass:
                                                                      "el-input__inner",
                                                                    staticStyle: {
                                                                      width:
                                                                        "200px"
                                                                    },
                                                                    attrs: {
                                                                      name:
                                                                        "subValue"
                                                                    },
                                                                    domProps: {
                                                                      value: list.itemResult.split(
                                                                        "_"
                                                                      )[1]
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.changeInp(
                                                                          $event,
                                                                          val,
                                                                          list,
                                                                          num
                                                                        )
                                                                      }
                                                                    }
                                                                  })
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              list.itemResult.split(
                                                                "_"
                                                              )[0] ==
                                                                "戴镜矫治" &&
                                                              val.subValue ==
                                                                "可疑"
                                                                ? _c(
                                                                    "el-select",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "show",
                                                                          rawName:
                                                                            "v-show",
                                                                          value:
                                                                            _vm.selShowCreate,
                                                                          expression:
                                                                            "selShowCreate"
                                                                        }
                                                                      ],
                                                                      staticStyle: {
                                                                        width:
                                                                          "200px"
                                                                      },
                                                                      on: {
                                                                        change: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.selChange(
                                                                            $event,
                                                                            list,
                                                                            val,
                                                                            num
                                                                          )
                                                                        }
                                                                      },
                                                                      model: {
                                                                        value: list.itemResult.split(
                                                                          "_"
                                                                        )[1],
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            list.itemResult.split(
                                                                              "_"
                                                                            ),
                                                                            1,
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "list.itemResult.split('_')[1]"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "el-option",
                                                                        {
                                                                          attrs: {
                                                                            label:
                                                                              "远视",
                                                                            value:
                                                                              "远视"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "el-option",
                                                                        {
                                                                          attrs: {
                                                                            label:
                                                                              "近视",
                                                                            value:
                                                                              "近视"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "el-option",
                                                                        {
                                                                          attrs: {
                                                                            label:
                                                                              "散光",
                                                                            value:
                                                                              "散光"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "el-option",
                                                                        {
                                                                          attrs: {
                                                                            label:
                                                                              "其他",
                                                                            value:
                                                                              "其他"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                : list.itemResult.split(
                                                                    "_"
                                                                  )[0] ==
                                                                  "戴镜矫治"
                                                                  ? _c(
                                                                      "el-select",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "show",
                                                                            rawName:
                                                                              "v-show",
                                                                            value:
                                                                              _vm.selShowCreate,
                                                                            expression:
                                                                              "selShowCreate"
                                                                          }
                                                                        ],
                                                                        staticStyle: {
                                                                          width:
                                                                            "200px"
                                                                        },
                                                                        on: {
                                                                          change: function(
                                                                            $event
                                                                          ) {
                                                                            _vm.selChange(
                                                                              $event,
                                                                              list,
                                                                              val,
                                                                              num
                                                                            )
                                                                          }
                                                                        },
                                                                        model: {
                                                                          value: list.itemResult.split(
                                                                            "_"
                                                                          )[1],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              list.itemResult.split(
                                                                                "_"
                                                                              ),
                                                                              1,
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "list.itemResult.split('_')[1]"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-option",
                                                                          {
                                                                            attrs: {
                                                                              label:
                                                                                "远视",
                                                                              value:
                                                                                "远视"
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-option",
                                                                          {
                                                                            attrs: {
                                                                              label:
                                                                                "近视",
                                                                              value:
                                                                                "近视"
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-option",
                                                                          {
                                                                            attrs: {
                                                                              label:
                                                                                "弱视",
                                                                              value:
                                                                                "弱视"
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-option",
                                                                          {
                                                                            attrs: {
                                                                              label:
                                                                                "斜视",
                                                                              value:
                                                                                "斜视"
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-option",
                                                                          {
                                                                            attrs: {
                                                                              label:
                                                                                "其他",
                                                                              value:
                                                                                "其他"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e()
                                                            ]
                                                          : list.itemResult.indexOf(
                                                              "_"
                                                            ) < 0
                                                            ? [
                                                                _c(
                                                                  "el-select",
                                                                  {
                                                                    ref:
                                                                      val.mecItemId,
                                                                    refInFor: true,
                                                                    staticStyle: {
                                                                      width:
                                                                        "200px"
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.customizeInput(
                                                                          $event,
                                                                          list,
                                                                          val,
                                                                          val.mecItemId
                                                                        )
                                                                      }
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        list.itemResult,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          list,
                                                                          "itemResult",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "list.itemResult"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._l(
                                                                      val.valueOptions.split(
                                                                        ","
                                                                      ),
                                                                      function(
                                                                        el
                                                                      ) {
                                                                        return [
                                                                          _c(
                                                                            "el-option",
                                                                            {
                                                                              key: el,
                                                                              attrs: {
                                                                                label: el,
                                                                                value: el
                                                                              }
                                                                            }
                                                                          )
                                                                        ]
                                                                      }
                                                                    )
                                                                  ],
                                                                  2
                                                                ),
                                                                _vm._v(" "),
                                                                list.itemResult ==
                                                                  "戴镜矫治" &&
                                                                val.subValue ==
                                                                  "可疑"
                                                                  ? _c(
                                                                      "el-select",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "show",
                                                                            rawName:
                                                                              "v-show",
                                                                            value:
                                                                              _vm.selShow,
                                                                            expression:
                                                                              "selShow"
                                                                          }
                                                                        ],
                                                                        staticStyle: {
                                                                          width:
                                                                            "200px"
                                                                        },
                                                                        on: {
                                                                          change: function(
                                                                            $event
                                                                          ) {
                                                                            _vm.selChangeVal(
                                                                              val,
                                                                              list,
                                                                              _vm.value
                                                                            )
                                                                          }
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.value,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.value = $$v
                                                                          },
                                                                          expression:
                                                                            "value"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-option",
                                                                          {
                                                                            attrs: {
                                                                              label:
                                                                                "远视",
                                                                              value:
                                                                                "远视"
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-option",
                                                                          {
                                                                            attrs: {
                                                                              label:
                                                                                "近视",
                                                                              value:
                                                                                "近视"
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-option",
                                                                          {
                                                                            attrs: {
                                                                              label:
                                                                                "散光",
                                                                              value:
                                                                                "散光"
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-option",
                                                                          {
                                                                            attrs: {
                                                                              label:
                                                                                "其他",
                                                                              value:
                                                                                "其他"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : list.itemResult ==
                                                                      "戴镜矫治" &&
                                                                    val.subValue !=
                                                                      "可疑"
                                                                    ? _c(
                                                                        "el-select",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                _vm.selShow,
                                                                              expression:
                                                                                "selShow"
                                                                            }
                                                                          ],
                                                                          staticStyle: {
                                                                            width:
                                                                              "200px"
                                                                          },
                                                                          on: {
                                                                            change: function(
                                                                              $event
                                                                            ) {
                                                                              _vm.selChangeVal(
                                                                                val,
                                                                                list,
                                                                                _vm.value
                                                                              )
                                                                            }
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm.value,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.value = $$v
                                                                            },
                                                                            expression:
                                                                              "value"
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "el-option",
                                                                            {
                                                                              attrs: {
                                                                                label:
                                                                                  "远视",
                                                                                value:
                                                                                  "远视"
                                                                              }
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "el-option",
                                                                            {
                                                                              attrs: {
                                                                                label:
                                                                                  "近视",
                                                                                value:
                                                                                  "近视"
                                                                              }
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "el-option",
                                                                            {
                                                                              attrs: {
                                                                                label:
                                                                                  "弱视",
                                                                                value:
                                                                                  "弱视"
                                                                              }
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "el-option",
                                                                            {
                                                                              attrs: {
                                                                                label:
                                                                                  "斜视",
                                                                                value:
                                                                                  "斜视"
                                                                              }
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "el-option",
                                                                            {
                                                                              attrs: {
                                                                                label:
                                                                                  "其他",
                                                                                value:
                                                                                  "其他"
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e()
                                                              ]
                                                            : _vm._e()
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  val.valueType == 2 ||
                                                  val.valueType == 1
                                                    ? _c("el-input", {
                                                        staticStyle: {
                                                          width: "200px"
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            _vm.changeInp(
                                                              $event,
                                                              val,
                                                              list,
                                                              num
                                                            )
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            list.itemResult,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              list,
                                                              "itemResult",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "list.itemResult"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ]
                                          ]
                                        : _vm._e()
                                    })
                                  ],
                                  2
                                )
                              : _vm._e()
                          })
                        ],
                        2
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                _c("div", { staticClass: "nav_gen" }, [
                  _c("span", { staticClass: "setLine" }, [
                    _vm._v("检查结果（医院评定）")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "setBtn" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-primary",
                          attrs: { type: "primary", size: "small" },
                          on: {
                            click: function($event) {
                              _vm.autoGenera()
                            }
                          }
                        },
                        [_vm._v("自动生成")]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { staticClass: "evaluate", attrs: { prop: "checkResult" } },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea", rows: 5, maxlength: 200 },
                      model: {
                        value: _vm.formInline.checkResult,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "checkResult", $$v)
                        },
                        expression: "formInline.checkResult"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "nav_gen" }, [
                  _c("span", { staticClass: "setLine" }, [_vm._v("医生意见")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "setBtn" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-primary",
                          attrs: { type: "primary", size: "small" },
                          on: {
                            click: function($event) {
                              _vm.checkTemplate()
                            }
                          }
                        },
                        [_vm._v("选用模板")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dialog",
                        {
                          staticClass: "innerDialog",
                          attrs: {
                            width: "60%",
                            title: "选用模板",
                            visible: _vm.innerVisible,
                            "append-to-body": "",
                            "before-close": _vm.handleClose,
                            "close-on-click-modal": false
                          },
                          on: {
                            "update:visible": function($event) {
                              _vm.innerVisible = $event
                            }
                          }
                        },
                        [
                          _c("div", [
                            _c("div", { staticClass: "module_left" }, [
                              _c("p", { staticClass: "msgtit" }, [
                                _vm._v("疾病名称")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    padding: "10px 10px 10px 10px"
                                  },
                                  attrs: { id: "dislist" }
                                },
                                [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      on: { change: _vm.checkContent },
                                      model: {
                                        value: _vm.checkedList,
                                        callback: function($$v) {
                                          _vm.checkedList = $$v
                                        },
                                        expression: "checkedList"
                                      }
                                    },
                                    _vm._l(_vm.diseaseList1, function(
                                      illnessName
                                    ) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: illnessName,
                                          staticStyle: { width: "100%" },
                                          attrs: { label: illnessName }
                                        },
                                        [_vm._v(_vm._s(illnessName))]
                                      )
                                    })
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "module_right" }, [
                              _c("p", { staticClass: "msgtit" }, [
                                _vm._v("模板内容")
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.moduleMain,
                                    expression: "moduleMain"
                                  }
                                ],
                                staticClass: "advice",
                                attrs: { id: "module_main" },
                                domProps: { innerHTML: _vm._s(_vm.html) }
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn-primary",
                                    staticStyle: { "margin-top": "20px" },
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function($event) {
                                        _vm.confirmModule()
                                      }
                                    }
                                  },
                                  [_vm._v("确定")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn-primary",
                                    staticStyle: { "margin-top": "20px" },
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function($event) {
                                        _vm.cancel()
                                      }
                                    }
                                  },
                                  [_vm._v("取消")]
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "evaluate",
                    attrs: { prop: "doctorSuggestion" }
                  },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea", rows: 5, maxlength: 2000 },
                      model: {
                        value: _vm.formInline.doctorSuggestion,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "doctorSuggestion", $$v)
                        },
                        expression: "formInline.doctorSuggestion"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "hold",
                    staticStyle: { "margin-top": "20px" }
                  },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            attrs: {
                              disabled: _vm.btnDis,
                              type: "primary",
                              size: "small"
                            },
                            on: {
                              click: function($event) {
                                _vm.submit(_vm.formInline)
                              }
                            }
                          },
                          [_vm._v("保存")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.setBtn,
                                expression: "setBtn"
                              }
                            ],
                            staticClass: "btn-primary",
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function($event) {
                                _vm.onReset("formInline")
                              }
                            }
                          },
                          [_vm._v("重置")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              2
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ibox-title" }, [
      _c("h5", { attrs: { id: "h5Title" } }, [_vm._v("儿童体检修改")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b5ce572", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b5ce572","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/physical/childPhyEdit.vue
// module id = null
// module chunks = 